import React, {useCallback, useState} from 'react';
import {Button, ButtonGroup, DropZone, Icon, Labelled, Stack, TextStyle} from '@shopify/polaris';
import {PageUpMajor} from '@shopify/polaris-icons';
import useCreateApi from '@assets/hooks/api/useCreateApi';
import {setToast} from '@assets/actions/layout/setToastAction';
import {store} from '@assets/index';
import {isObject} from 'lodash';

export default function ImportForm({closeModal, successCallback = () => {}}) {
  const [importFile, setImportFile] = useState(null);
  const [error, setError] = useState(null);

  const onDrop = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) => setImportFile(acceptedFiles[0]),
    []
  );

  const {creating, handleCreate} = useCreateApi({
    url: '/purchase-order/import',
    fullResp: true
  });

  const onImport = async () => {
    setError(false);
    const formData = new FormData();
    formData.append('file', importFile);

    const {success, data, message = null} = await handleCreate(formData);

    if (!success) {
      setError(message ?? data);
      return;
    }

    closeModal();
    successCallback();
  };

  const renderError = useCallback(() => {
    if (!error) return null;
    if (isObject(error)) {
      return <pre>{JSON.stringify(error, null, 2)}</pre>;
    }
    return error;
  }, [error]);

  return (
    <Stack vertical>
      <Labelled id="" label="" error={renderError()}>
        <DropZone
          type="file"
          accept="text/csv"
          allowMultiple={false}
          onDrop={onDrop}
          disabled={creating}
          error={error}
        >
          {!!importFile ? (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100%'
              }}
            >
              <div>
                <Stack vertical alignment="center" spacing="extraTight">
                  <Icon source={PageUpMajor} color="subdued" />
                  <TextStyle variation="strong">{importFile?.name}</TextStyle>
                  <TextStyle>{importFile?.type}</TextStyle>
                </Stack>
              </div>
            </div>
          ) : (
            <DropZone.FileUpload
              actionTitle={'Select CSV file to import'}
              actionHint="Accepts only .csv"
            />
          )}
        </DropZone>
      </Labelled>
      <div style={{display: 'flex', justifyContent: 'flex-end'}}>
        <ButtonGroup>
          <Button onClick={closeModal} disabled={creating} loading={creating}>
            Cancel
          </Button>
          <Button disabled={creating} loading={creating} primary onClick={onImport}>
            Import
          </Button>
        </ButtonGroup>
      </div>
    </Stack>
  );
}
